import { markTypesToCheck } from '@components/userDocuments/editDocument/editJournal/slateUtilities/renderMarksEnums';
import Logger from '@utility/services/Logger';

const removeMarksFromValue = (value) => {
  try {
    const { document } = value;
    const processNode = (node) => {
      if (node?.object === 'text') {
        const newLeaves = node?.leaves?.map((leaf) => {
          const filteredMarks = leaf?.marks?.filter(
            (mark) => !markTypesToCheck.includes(mark?.type),
          );

          return filteredMarks?.size !== leaf?.marks?.size
            ? leaf.set('marks', filteredMarks)
            : leaf;
        });

        return node.set('leaves', newLeaves);
      }

      if (node?.nodes) {
        const newNodes = node?.nodes?.map(processNode);
        return node.set('nodes', newNodes);
      }

      return node;
    };

    const newDocument = document.mapDescendants(processNode);
    return value.set('document', newDocument);
  } catch (e) {
    Logger.LogError('Error in removeMarksFromValue: ', e);
    return value;
  }
};

export default removeMarksFromValue;
